import { create } from 'zustand';
import { api } from '../services/api';

export const useUsersStore = create((set, get) => ({
  users: [],
  total: 0,
  limit: 20,
  offset: 0,
  isLoading: false,
  error: null,
  filters: {},

  // Загрузка пользователей
  fetchUsers: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const queryParams = {
        limit: params.limit || get().limit,
        offset: params.offset || 0,
        ...params,
      };
      
      const data = await api.getUsers(queryParams);
      set({
        users: data.users,
        total: data.total,
        limit: data.limit,
        offset: data.offset,
        filters: params,
        isLoading: false,
      });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка одного пользователя
  fetchUser: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const user = await api.getUser(id);
      set({ isLoading: false });
      return user;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Блокировать пользователя
  blockUser: async (id) => {
    try {
      await api.blockUser(id);
      // Обновляем список
      get().fetchUsers(get().filters);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Разблокировать пользователя
  unblockUser: async (id) => {
    try {
      await api.unblockUser(id);
      get().fetchUsers(get().filters);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Обновить баланс
  updateUserBalance: async (id, balance) => {
    try {
      await api.updateUserBalance(id, balance);
      get().fetchUsers(get().filters);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Удалить пользователя
  deleteUser: async (id) => {
    try {
      await api.deleteUser(id);
      get().fetchUsers(get().filters);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Обновить пользователя в списке (локально)
  updateUserInList: (id, updates) => {
    set((state) => ({
      users: state.users.map((user) =>
        user.id === id ? { ...user, ...updates } : user
      ),
    }));
  },

  // Очистка
  clear: () => {
    set({ users: [], total: 0, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
